/* esm.sh - @smithy/core@3.24.3/endpoints */
export * from "/*@smithy/core@3.24.3/esnext/endpoints.mjs";
